export const buildPots = (players) => {
    const contributors = players.filter((p) => p.committedTotal > 0);
    const levels = [...new Set(contributors.map((p) => p.committedTotal))].sort((a, b) => a - b);
    const pots = [];
    let prevLevel = 0;
    for (const level of levels) {
        const layerContributors = contributors.filter((p) => p.committedTotal >= level);
        const amount = (level - prevLevel) * layerContributors.length;
        if (amount > 0) {
            const eligibleSeats = layerContributors.filter((p) => !p.folded).map((p) => p.seat);
            pots.push({ amount, eligibleSeats });
        }
        prevLevel = level;
    }
    // Merge adjacent layers with identical eligibility - cosmetic (fewer, larger pots) but keeps
    // `pots` from fragmenting into many same-eligibility slices whenever stack sizes differ slightly.
    const merged = [];
    for (const pot of pots) {
        const last = merged[merged.length - 1];
        if (last && sameEligibility(last.eligibleSeats, pot.eligibleSeats)) {
            last.amount += pot.amount;
        }
        else {
            merged.push({ ...pot });
        }
    }
    return merged;
};
const sameEligibility = (a, b) => a.length === b.length && a.every((seat, i) => seat === b[i]);
//# sourceMappingURL=sidepots.js.map